import { supabase } from '../lib/supabaseClient';

// Menu ID for The Wild Garden
const MENU_ID = 'wild_garden';

/**
 * Fetch all menu categories with their items
 * @returns {Promise<Object>} Menu data organized by category ID
 */
export const fetchMenuData = async () => {
  try {
    // Fetch categories for The Wild Garden menu
    const { data: categories, error: categoriesError } = await supabase
      .from('categories')
      .select('*')
      .eq('menu_id', MENU_ID)
      .order('order_index', { ascending: true });

    if (categoriesError) throw categoriesError;

    // Fetch all menu items
    const { data: items, error: itemsError } = await supabase
      .from('items')
      .select('*');

    if (itemsError) throw itemsError;

    // Organize data by category
    const menuData = {};
    categories.forEach(category => {
      menuData[category.id] = {
        id: category.id,
        name: category.name,
        description: category.description || '',
        items: items
          .filter(item => item.category_id === category.id)
          .sort((a, b) => (a.order_index || 0) - (b.order_index || 0)) // Sort by custom order
          .map(item => ({
            name: item.name,
            price: item.price,
            description: item.description || ''
          }))
      };
    });

    return menuData;
  } catch (error) {
    console.error('Error fetching menu data:', error);
    throw error;
  }
};

/**
 * Fetch a single category with its items
 * @param {string} categoryId - The category ID to fetch
 * @returns {Promise<Object>} Category data with items
 */
export const fetchCategory = async (categoryId) => {
  try {
    // Fetch category
    const { data: category, error: categoryError } = await supabase
      .from('categories')
      .select('*')
      .eq('id', categoryId)
      .single();

    if (categoryError) throw categoryError;
    if (!category) return null;

    // Fetch category items
    const { data: items, error: itemsError } = await supabase
      .from('items')
      .select('*')
      .eq('category_id', categoryId);

    if (itemsError) throw itemsError;

    return {
      id: category.id,
      name: category.name,
      description: category.description || '',
      items: items
        .sort((a, b) => (a.order_index || 0) - (b.order_index || 0)) // Sort by custom order
        .map(item => ({
          name: item.name,
          price: item.price,
          description: item.description || ''
        }))
    };
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
};

